import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { HandleToken } from 'services/Generic/Generic'
import { logger } from 'utils/logger'

import { NO_TOKEN_URL } from './utils'

enum ApiType {
  Cdu,
  Read,
  Login,
  LoginSSO,
  Gst
}

export const getApiURL = (api: ApiType): string => {
  if (api === ApiType.Cdu) {
    return process.env.REACT_APP_API_CDU_URL
  }

  if (api === ApiType.Read) {
    return process.env.REACT_APP_API_READ_URL
  }

  if (api === ApiType.Login) {
    return process.env.REACT_APP_API_LOGIN_URL
  }

  if (api === ApiType.LoginSSO) {
    return process.env.REACT_APP_API_LOGIN_SSO_URL
  }

  return process.env.REACT_APP_API_GST_URL
}

const getAxiosConfiguration = (api: ApiType) => ({
  baseURL: getApiURL(api),
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  withCredentials: api === ApiType.Cdu
})

async function requestHandler(request: AxiosRequestConfig) {
  if (!NO_TOKEN_URL.includes(window.location.hash)) {
    request.headers.Authorization = await HandleToken()
  }

  logger.info(request)
  return request
}

function responseHandler(response: AxiosResponse) {
  logger.info(response)
  return response
}

const errorHandler = (error: any) => {
  logger.error(error)
  return Promise.reject(error)
}

export {
  getAxiosConfiguration,
  ApiType,
  requestHandler,
  responseHandler,
  errorHandler
}
